import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

import type { BookingType } from './getBookings';

export const getBookingTypes = async (): Promise<BookingType[]> => {
  try {
    const response = await apiService.get<BookingType[]>('/booking-types/');

    return response.data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
